import { LogLevel } from '@core/logging';
import { EnvironmentBase } from './environment.base';

export const environment: EnvironmentBase = {
  production: false,
  logLevel: LogLevel.All,
  hmr: false,
  aadAuthorityDomain: 'pasb2cdev.b2clogin.com',
  aadClientId: '0e5f6a80-7d33-4eb6-961f-710d8c1e4e5a',
  aadEditprofileUrl: 'https://pasb2cdev.b2clogin.com/pasb2cdev.onmicrosoft.com/B2C_1_PasswordReset',
  aadScope: 'https://pasb2cdev.onmicrosoft.com/pas-gup-backend-dev/FullAccess',
  aadSignupSigninUrl:
    'https://pasb2cdev.b2clogin.com/pasb2cdev.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
  baseUrl: 'https://pas-gup-backend-uat.pasmapps.de',
};
